import { Component, Input } from '@angular/core';

import { FileUtil } from 'rev-shared/util/FileUtil';

import { IVideoPlaybackConfig } from './IVideoPlaybackConfig';

import styles from './video-supplemental-content.module.less';

@Component({
	selector: 'video-supplemental-content',
	templateUrl: './VideoSupplementalContent.Component.html'
})
export class VideoSupplementalContentComponent {
	@Input() public supplementalContents: any;
	@Input() public playbackConfig: IVideoPlaybackConfig;

	public readonly styles = styles;

	public getFileExtensionClass(extension: string): string {
		return FileUtil.getFileExtensionCssClass(extension);
	}
}
